"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityCreatedUpdated = exports.EntityCreatedUpdatedDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var entity_author_1 = require("./entity-author");
exports.EntityCreatedUpdatedDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
var CreatedStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(6))
});
var UpdatedStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  "], ["\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme_1.theme.UNIT(6))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Created: (0, styled_components_1.default)(entity_author_1.EntityAuthor)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), CreatedStyles),
  Updated: (0, styled_components_1.default)(entity_author_1.EntityAuthor)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), UpdatedStyles)
};
var EntityCreatedUpdated = function (props) {
  var className = props.className,
    entity = props.entity;
  var showCreated = !!entity.createdBy;
  var showUpdated = !!entity.updatedBy;
  var dateCreated = entity.created && new Date(entity.created);
  var dateUpdated = entity.updated && new Date(entity.updated);
  // if the different between update and create dates is small, assume this is the same operation
  if (showUpdated && dateUpdated && dateCreated) {
    var dateCreatedValue = dateCreated.valueOf();
    var dateUpdatedValue = dateUpdated.valueOf();
    showUpdated = dateUpdatedValue - dateCreatedValue > 10000;
  }
  return react_1.default.createElement(My.Container, {
    className: className
  }, showCreated && react_1.default.createElement(My.Created, {
    type: "creator",
    entity: entity
  }), showUpdated && react_1.default.createElement(My.Updated, {
    type: "updater",
    entity: entity
  }));
};
exports.EntityCreatedUpdated = EntityCreatedUpdated;
exports.EntityCreatedUpdated.defaultProps = exports.EntityCreatedUpdatedDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;